import Vue from 'vue';
import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import commonAPI from '@/utils/api/common';
import { genericError } from '@/utils/alerts.service';

export const agencyDetailLocations = {
  namespaced: true,
  state: {
    locations: [],
    newLocations: [],
    locationsToDelete: [],
    countries: [],
    states: [],
    cities: [],
  },

  getters: {
    locations(state) {
      return state.locations;
    },

    newLocations(state) {
      return state.newLocations;
    },

    countries(state) {
      return state.countries;
    },

    states(state) {
      return state.states;
    },

    cities(state) {
      return state.cities;
    },
  },

  mutations: {
    setLocations(state, data) {
      state.locations = data;
    },

    setCountries(state, countries) {
      state.countries = countries;
    },

    setStates(state, states) {
      state.states = states;
    },

    setCities(state, cities) {
      state.cities = cities;
    },

    markLocationForDelete(state, index) {
      state.locations[index].delete = true;

      // Need to keep track of deleting items to merge with rendered array on save
      state['locationsToDelete'].push(state.locations[index]);

      // Remove deleted items from rendered array
      state.locations = state.locations.filter(i => {
        return !i.delete;
      });

      // Need to reassign order since one item was removed
      state.locations = state.locations.map((item, i) => {
        return {
          ...item,
          order: i,
        };
      });
    },

    updateLocation(state, payload) {
      Vue.set(state.locations, payload.data.index, payload.data);
    },

    addLocation(state, payload) {
      state.locations.push(payload.data);
    },
  },
  actions: {
    updateLocation({ commit }, payload) {
      commit('updateLocation', payload);
    },

    removeLocation({ commit }, index) {
      commit('markLocationForDelete', index);
    },

    addLocation({ commit }) {
      commit('addLocation');
    },

    clearCities({ commit }) {
      commit('setCities', []);
    },

    async fetchLocations({ dispatch, commit }, id) {
      return vendorDashboardAPI
        .getPartnerLocations(id)
        .then(data => {
          const results = data.results.map(i => {
            // to get data in correct format for front-end to work with
            return {
              id: i.id,
              city: {
                key: i.cityObj.name,
                value: i.city,
              },
              country: {
                key: i.countryObj.name,
                value: i.country,
              },
              region: {
                key: i.regionObj.name,
                value: i.region,
              },
            };
          });
          commit('setLocations', results);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async fetchCountries({ commit, dispatch }) {
      return new Promise(resolve => {
        return commonAPI
          .getCountries()
          .then(data => {
            commit('setCountries', data);
            resolve(data);
          })
          .catch(() => {
            dispatch('showUserMessage', { ...genericError }, { root: true });
            resolve();
          });
      });
    },

    async fetchStates({ commit, dispatch }, id) {
      return new Promise(resolve => {
        return commonAPI
          .getStates(id)
          .then(data => {
            commit('setStates', data);
            resolve(data);
          })
          .catch(() => {
            dispatch('showUserMessage', { ...genericError }, { root: true });
            resolve();
          });
      });
    },

    async fetchCities({ commit, dispatch }, payload) {
      return new Promise(resolve => {
        return commonAPI
          .getCities(payload)
          .then(data => {
            commit('setCities', data);
            resolve(data);
          })
          .catch(() => {
            dispatch('showUserMessage', { ...genericError }, { root: true });
            resolve();
          });
      });
    },

    saveAdditionalLocations({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        const locations = state.locations.map(location => {
          return {
            ...location,
            country: location.country.value,
            region: location.region.value,
            city: location.city.value,
          };
        });

        const locationsToDelete = state.locationsToDelete.map(location => {
          return {
            ...location,
            country: location.country.value,
            region: location.region.value,
            city: location.city.value,
          };
        });

        const data = [...locations, ...locationsToDelete];
        return vendorDashboardAPI
          .savePartnerLocations(id, data)
          .then(() => {
            commit('addSaveProgress', null, { root: true });
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
};
